[
  {
    "id": "typ",
    "nr": 1,
    "sort": "val",
    "text": "Vad är platsen?",
    "hjalp": "Svaret avgör vad appen visar. En båt kan inte bli ett hus, eller tvärtom.",
    "alternativ": [
      { "id": "bat", "text": "Båt" },
      { "id": "hus", "text": "Hus" },
      { "id": "fritidshus", "text": "Fritidshus" },
      { "id": "husbil", "text": "Husbil" },
      { "id": "annat", "text": "Något annat" }
    ],
    "forval": null
  },
  {
    "id": "fynd",
    "nr": 2,
    "sort": "lista",
    "text": "Det här hittade vi",
    "hjalp": {
      "batkoll": "Det som navet hör ombord. Bocka i det som hör till båten. En okänd enhet kan få ett namn, eller hoppas över.",
      "stugkoll": "Det som navet hör i huset. Bocka i det som hör till platsen. En okänd enhet kan få ett namn, eller hoppas över.",
      "husbilskoll": "Det som navet hör i husbilen. Bocka i det som hör till husbilen. En okänd enhet kan få ett namn, eller hoppas över."
    },
    "alternativ": [],
    "forval": null
  },
  {
    "id": "mall",
    "nr": 3,
    "sort": "val",
    "text": "Vilken mall passar?",
    "hjalp": {
      "batkoll": "Förslaget kommer ur det som navet hör. Motorerna, tankarna och matningen kan ändras under Inställningar → Båten.",
      "stugkoll": "Mallen ger korten, gränserna och larmen som förval.",
      "husbilskoll": "Mallen ger korten, gränserna och larmen som förval."
    },
    "alternativ": [],
    "forval": null
  },
  {
    "id": "omraden",
    "nr": 4,
    "sort": "flerval",
    "text": "Vad vill du ha koll på?",
    "hjalp": "Allt är förvalt. Det du väljer bort visas inte i förslaget.",
    "alternativ": [
      { "id": "el", "text": "El och batterier" },
      { "id": "varme", "text": "Värme" },
      { "id": "vatten", "text": "Vatten och fukt" },
      { "id": "vader", "text": "Väder" },
      { "id": "motor", "text": { "batkoll": "Motor och bränsle" } },
      { "id": "sakerhet", "text": "Säkerhet: inbrott, rörelse och länspump, bara läsning" },
      { "id": "kameror", "text": "Kameror (kommer senare)" }
    ],
    "forval": ["el", "varme", "vatten", "vader", "motor", "sakerhet"]
  },
  {
    "id": "drift",
    "nr": 5,
    "sort": "val",
    "text": {
      "batkoll": "Är båten i drift nu, eller i vinterförvaring?",
      "stugkoll": "Används platsen nu, eller är den stängd för säsongen?",
      "husbilskoll": "Används husbilen nu, eller är den i vinterförvaring?"
    },
    "hjalp": {
      "batkoll": "En båt som inte är i drift får inga varningar om att navet är tyst. Vinterläget för laddarna slås på under Inställningar → Vinterläge, med två ja.",
      "stugkoll": "En plats som inte är i drift får inga varningar om att navet är tyst.",
      "husbilskoll": "En husbil som inte är i drift får inga varningar om att navet är tyst."
    },
    "alternativ": [
      { "id": "i_drift", "text": "I drift" },
      {
        "id": "ej_i_drift",
        "text": {
          "batkoll": "I vinterförvaring",
          "stugkoll": "Stängd för säsongen",
          "husbilskoll": "I vinterförvaring"
        }
      }
    ],
    "forval": "i_drift"
  },
  {
    "id": "larm",
    "nr": 6,
    "sort": "larm",
    "text": "Hur vill du få larmen?",
    "hjalp": "Push slås på för den här enheten. Akut och Varning kommer med push, Info utan. Under dina tysta tider kommer Varning utan ljud. Akut kommer alltid med ljud.",
    "alternativ": [
      { "id": "push", "text": "Push på den här enheten" },
      { "id": "epost", "text": "E-post (finns inte än)" }
    ],
    "forval": ["push"]
  },
  {
    "id": "konton",
    "nr": 7,
    "sort": "konton",
    "text": "Vem mer ska se platsen?",
    "hjalp": "En läsare ser platsen. En ägare kan också ändra inställningarna. De får en inbjudan med e-post.",
    "alternativ": [{ "id": "lasare", "text": "Läsare" }, { "id": "agare", "text": "Ägare" }],
    "forval": null
  },
  {
    "id": "badtemperatur",
    "nr": 8,
    "sort": "ja_nej",
    "text": "Ska badtemperaturen visas?",
    "hjalp": "Kortet Badtemperatur på Hälsa: vattnets temperatur från en givare, en station i närheten eller Copernicus Marine.",
    "alternativ": [],
    "forval": true
  }
]
